import { IconName } from '@ardoq/icons';
import { v4 as uuidv4 } from 'uuid';
import { HelperTextRow } from '../types';

const temporaryIdPrefix = 'created-in-inventory-';

const isComponentNotPersisted = (id: string) => {
  return id.startsWith(temporaryIdPrefix);
};

/**
 * AG Grid uses _id property to identify rows, therefore we need to generate temporary id for newly created components.
 * When we save those, we remove rows with temporary id and replace them with the ones that have real id.
 */
const getComponentTemporaryId = () => {
  return `${temporaryIdPrefix}${uuidv4()}`;
};

const getFakeRowWithHelperText = (): HelperTextRow => {
  return {
    _id: 'create-new-component-helper-text-row',
    helperTextStyle: 'info',
    helperText:
      'New components will appear above this line. Once you are finished creating, components will follow sorting and filtering rules.',
    leftIconName: IconName.INFO,
  };
};

const isCreateComponentHelperTextRow = (rowId: string) => {
  return rowId === 'create-new-component-helper-text-row';
};

const getTopRowId = (componentId: string) => {
  return `top-pinned-${componentId}`;
};

const isComponentNotPersistedAndHasOnlyPresetValues = (
  component: Record<string, any>
) => {
  const hasOnlyPresetValues = !Object.keys(component).some(
    attribute =>
      !['_id', 'rootWorkspace', 'typeId', 'model'].includes(attribute) &&
      component[attribute] !== undefined
  );
  return isComponentNotPersisted(component._id) && hasOnlyPresetValues;
};

export const createComponentsOperations = {
  isComponentNotPersisted,
  getComponentTemporaryId,
  getFakeRowWithHelperText,
  isCreateComponentHelperTextRow,
  getTopRowId,
  isComponentNotPersistedAndHasOnlyPresetValues,
};
